/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategyExecutionExportSettings = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The StrategyExecutionExportSettings model module.
   * @module model/StrategyExecutionExportSettings
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>StrategyExecutionExportSettings</code>.
   * @alias module:model/StrategyExecutionExportSettings
   * @class
   */
  var exports = function() {
    var _this = this;







  };

  /**
   * Constructs a <code>StrategyExecutionExportSettings</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StrategyExecutionExportSettings} obj Optional instance to populate.
   * @return {module:model/StrategyExecutionExportSettings} The populated <code>StrategyExecutionExportSettings</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('ExportAll')) {
        obj['ExportAll'] = ApiClient.convertToType(data['ExportAll'], 'Boolean');
      }
      if (data.hasOwnProperty('UseSimplifiedFormat')) {
        obj['UseSimplifiedFormat'] = ApiClient.convertToType(data['UseSimplifiedFormat'], 'Boolean');
      }
      if (data.hasOwnProperty('StrategyDescriptionIDs')) {
        obj['StrategyDescriptionIDs'] = ApiClient.convertToType(data['StrategyDescriptionIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('StrategicGoalIDs')) {
        obj['StrategicGoalIDs'] = ApiClient.convertToType(data['StrategicGoalIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('StrategicGoalMilestoneIDs')) {
        obj['StrategicGoalMilestoneIDs'] = ApiClient.convertToType(data['StrategicGoalMilestoneIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('StrategicProgramIDs')) {
        obj['StrategicProgramIDs'] = ApiClient.convertToType(data['StrategicProgramIDs'], ['Integer']);
      }
    }
    return obj;
  }

  /**
   * @member {Boolean} ExportAll
   * @default false
   */
  exports.prototype['ExportAll'] = false;
  /**
   * @member {Boolean} UseSimplifiedFormat
   * @default false
   */
  exports.prototype['UseSimplifiedFormat'] = false;
  /**
   * @member {Array.<Integer>} StrategyDescriptionIDs
   */
  exports.prototype['StrategyDescriptionIDs'] = undefined;
  /**
   * @member {Array.<Integer>} StrategicGoalIDs
   */
  exports.prototype['StrategicGoalIDs'] = undefined;
  /**
   * @member {Array.<Integer>} StrategicGoalMilestoneIDs
   */
  exports.prototype['StrategicGoalMilestoneIDs'] = undefined;
  /**
   * @member {Array.<Integer>} StrategicProgramIDs
   */
  exports.prototype['StrategicProgramIDs'] = undefined;



  return exports;
}));


